<!--Tabla-->
<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>


    <div class="projects">
        <div class="card">
            <div class="card-header header-background">
                <p class="welcome-title">Bienvenida, <b>{{primerNombreDirectora}}</b></p>
            </div>

            <div class="card-body" >
                <div class="special-padding">

                    <p>¡Bienvenida al <b>Escritorio Digital del Jardín Infantil</b>!</p>

                    <p>Esta plataforma innovadora centraliza y facilita el acceso a los instrumentos técnico-pedagógicos esenciales para la gestión educativa integral de más de 1.350 jardines infantiles.​</p>

                    <p>El <b>Escritorio Digital del Jardín Infantil</b> se alinea con los ejes institucionales de:​</p>

                    <p> <b>Calidad Educativa</b>, al aportar al fortalecimiento de la calidad de la gestión educativa integral de los jardines infantiles, favoreciendo procesos eficientes desde un enfoque sostenible e innovador ajustado a estándares de calidad pertinentes a los programas educativos de la institución.​</p>
                        
                    <p> <b>Modernización Institucional</b>, al optimizar procesos técnico- pedagógicos mediante herramientas digitales que los hagan eficientes, oportunos y contribuyan con información para la toma de decisiones informadas. Junto a lo anterior, propicia la reducción del uso de papel y la transformación digital.​</p>
              
                    <p>Esperamos que disfrute de una experiencia innovadora e interactiva, llena de oportunidades para aprender.</p>

                    <br>

                    <div class="row mt-2 mb-2" style="display: none; background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px;width: 100%; padding: 10px;">
                        <div class="col-sm-8">
                            <p style="text-align: left;letter-spacing: 0px;color: #597CEE;">Revise nuestra sección de "Preguntas Frecuentes" antes de realizar cualquier consulta.</p>
                        </div>
                        <div class="col-sm-4" style="text-align: right;">
                            <button type="button" class="btn btn-light btn-send" (click)='preguntasFrecuentes()'> IR
                                A SECCIÓN</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



        
